// extracted by mini-css-extract-plugin
export default {"container":"DatePicker_container__rDFSZ","label":"DatePicker_label__TVMRs","datepicker":"DatePicker_datepicker__fTAPn","error":"DatePicker_error__dEQMF"};